import { Component, OnInit } from '@angular/core';

import { SessionStaffing, SessionStaffingService } from '../../../../_services';

@Component({
    selector: 'create-new-virtual-session.component',
    templateUrl: './create.component.html',
})
export class SessionStaffingCreateComponent implements OnInit {
    error: string;
    success: string;
    virtualSession: SessionStaffing;

    constructor(private sessionStaffingService: SessionStaffingService) {}

    ngOnInit() {
        this.virtualSession = new SessionStaffing(
            null,
            '',
            '',
            '',
            new Date(),
            false
        );
    }

    save() {
        // TODO
        this.sessionStaffingService.create(this.virtualSession).subscribe(
            (response) => {
                this.error = null;
                this.success = 'OK';
                window.location.href = '#/sessions/staffing/' + response.id;
            },
            () => {
                this.success = null;
                this.error = 'ERROR';
            }
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/_screens/session/staffing/create/create.component.ts